import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2.855 4.937a11.252 11.252 0 0 1 17.569.068M3.362 15.75v-7.5l3 7.5v-7.5m6 7.5h-1.5a1.5 1.5 0 0 1-1.5-1.5v-4.5a1.5 1.5 0 0 1 1.5-1.5h1.5m-3 4.5h3m3-4.5v2.017a9 9 0 0 0 .644 3.342l.856 2.141 1.5-5.25 1.5 5.25.857-2.141a9 9 0 0 0 .643-3.342V8.25M2.637 18.75a11.226 11.226 0 0 0 17.959.023"
    }, null, -1)
  ]));
}
const tagNewCircle = { render };
export {
  tagNewCircle as default,
  render
};
//# sourceMappingURL=tag-new-circle.svg.js.map
